import fetch from 'isomorphic-fetch';
import ENV from '../environments/environment'


const landingService = {

   async getLandingData(token) {
     const response = await fetch(`${ENV.lupita_url}orders/promos/${token}` , { headers: ENV.getLupitaHeaders() });
     return await response.json();
   },

   async getProducts( products, coords, query) {
     let data = {
      	"lat" : coords[0],
      	"lng" : coords[1],
      	"product_ids" : products,
      	"query_type" : "type",
      	"query" : query
     }
     const response = await fetch(`${ENV.lupita_url}stores/products/by-zone/` , { headers: ENV.getLupitaHeaders()  , method: 'POST', body: JSON.stringify(data) } );
     return await response.json();
   },

   async getAlgoliaProducts(query, store_id) {
     let headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
     }
    let data = {"params":`query=${query}&filters=(store_id%3A${store_id})%20AND%20is_available%20%3D%201&hitsPerPage=50`};
    let url =  "https://ic74gbc39n-dsn.algolia.net/1/indexes/production_products_web_mx/query?x-algolia-agent=Algolia%20for%20vanilla%20JavaScript%203.21.1&x-algolia-application-id=IC74GBC39N&x-algolia-api-key=d893fe7eb4719fa12151fc0054625872"
    const response = await fetch(url , { headers: headers  , method: 'POST', body: JSON.stringify(data) } );
    return await response.json();
   }

}

export default landingService;



// WEBPACK FOOTER //
// ./src/services/landing.service.js